@import 'styles/variables.scss';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.textField {
  display: flex;
  width: 100%;
  padding: 0 0 0 8px;
  column-gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--neutral-10);
  margin-right: 4px;
  min-width: 247px;
  transition: min-width 150ms ease-in-out;

  &.isFocused {
    min-width: 544px;
    border: 2px solid var(--selected-stroke);
    margin-left: -1px;

    .icon {
      color: var(--selected-stroke);
    }
  }

  .promptInput {
    box-shadow: none;
    padding: 0;

    [data-autopilot-system-redesign='on'] & {
      border: none;
      border-radius: 8px;
    }
  }

  .textarea {
    border-radius: 8px;
  }

  .icon {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    align-self: flex-start;
    position: relative;
    top: 6px;
    color: initial;
  }

  &.md {
    .textarea {
      height: 32px;
      padding: 5px 0;
    }

    .icon {
      top: 7px;
    }

    @include for-phone-only {
      background-color: var(--light-100);
      margin-right: 0;
      border: 2px solid var(--neutral-10);
      column-gap: 0;

      &.isFocused {
        margin-left: 0;
        border: 2px solid var(--selected-stroke);
      }

      .icon {
        height: 24px;
      }
      .textarea {
        height: 36px;
        padding: 8px 10px;
      }
    }
  }
}

.menu {
  min-width: 154px;
}
